import {
    MASTERBALANCE_REQUEST,
    MASTERBALANCE_SUCCESS,
    MASTERBALANCE_FAILURE,
    VIRTUALACCOUNTSUBACCOUNTBALANCE_REQUEST,
    VIRTUALACCOUNTSUBACCOUNTBALANCE_SUCCESS,
    VIRTUALACCOUNTSUBACCOUNTBALANCE_FAILURE,
    CUSTOMERTRANSACTION_REQUEST,
    CUSTOMERTRANSACTION_SUCCESS,
    CUSTOMERTRANSACTION_FAILURE,
    FX_RATE_REF_REQ,
    FX_RATE_REF_SUCCESS,
    FX_RATE_REF_FAILURE,
    FX_RATE_REF_SUCCESS_REGULAR,
    COUNT_BENEFICIARY_VA_REQUEST,
    COUNT_BENEFICIARY_VA_FAILURE,
    COUNT_BENEFICIARY_VA_SUCCESS,
    GET_BALANCE_CUSTOMER_REQUEST,
    GET_BALANCE_CUSTOMER_FAILURE,
    GET_BALANCE_CUSTOMER_SUCCESS,
    BANK_SUBLEDGER_BALANCE_REQUEST,
    BANK_SUBLEDGER_BALANCE_SUCCESS,
    BANK_SUBLEDGER_BALANCE_FAILURE,
    RIPPLE_BALANCE_REQUEST, RIPPLE_BALANCE_SUCCESS, RIPPLE_BALANCE_FAILURE,
} from "./dashboardType";

import {
    getAccountBalance,
    getVirtualAccountSubAccountBalance,
    getBankSubledgerSubAccountBalance,
    getCustomerTransactions,
    getFxRateRefApi, countBeneVAOfCustomerApi, callAccountRippleBalanceApi
} from "../../api/api";


export const callGetMasterBalance = () => {
    return async (dispatch) => {
        dispatch(masterBalanceRequest());
        try {
            var response = await getAccountBalance();
            // return data
            dispatch(masterBalanceSuccess(response));
        } catch (error) {
            dispatch(masterBalanceFailure(error.message));
        }
    };
};


export const callAccountRippleBalance = () => {
    return async (dispatch) => {
        dispatch(callAccountRippleBalanceReq());
        try {
            var response = await callAccountRippleBalanceApi();
            // return data
            dispatch(callAccountRippleBalanceSuccess(response));
        } catch (error) {
            dispatch(callAccountRippleBalanceFailure(error.message));
        }
    };
};

const callAccountRippleBalanceReq = () => {
    return {
        type: RIPPLE_BALANCE_REQUEST,
    };
};

const callAccountRippleBalanceSuccess = (payloat) => {
    return {
        type: RIPPLE_BALANCE_SUCCESS,
        payload: payloat
    };
};

const callAccountRippleBalanceFailure = (error) => {
    return {
        type: RIPPLE_BALANCE_FAILURE,
        payload: error
    };
};


export const callBankSubledgerBalance = () => {
    return async (dispatch) => {
        dispatch(callBankSubledgerBalanceReq());
        try {
            var response = await getBankSubledgerSubAccountBalance();
            // return data
            dispatch(callBankSubledgerBalanceSuccess(response));
        } catch (error) {
            dispatch(callBankSubledgerBalanceFailure(error.message));
        }
    };
};

const callBankSubledgerBalanceReq = () => {
    return {
        type: BANK_SUBLEDGER_BALANCE_REQUEST,
    };
};

const callBankSubledgerBalanceSuccess = (payloat) => {
    return {
        type: BANK_SUBLEDGER_BALANCE_SUCCESS,
        payload: payloat
    };
};

const callBankSubledgerBalanceFailure = (error) => {
    return {
        type: BANK_SUBLEDGER_BALANCE_FAILURE,
        payload: error
    };
};


export const countBeneVAOfCustomer = () => {
    return async (dispatch) => {
        dispatch(countActiveBeneficiaryVAReq());
        try {
            var response = await countBeneVAOfCustomerApi();
            // return data
            dispatch(countActiveBeneficiaryVASuccess(response));
        } catch (error) {
            dispatch(countActiveBeneficiaryVAFailure(error.message));
        }
    };
};

const countActiveBeneficiaryVAReq = () => {
    return {
        type: COUNT_BENEFICIARY_VA_REQUEST,
    };
};

const countActiveBeneficiaryVASuccess = (payloat) => {
    return {
        type: COUNT_BENEFICIARY_VA_SUCCESS,
        payload: payloat
    };
};

const countActiveBeneficiaryVAFailure = (error) => {
    return {
        type: COUNT_BENEFICIARY_VA_FAILURE,
        payload: error
    };
};

const masterBalanceRequest = () => {
    return {
        type: MASTERBALANCE_REQUEST,
    };
};
  
const masterBalanceSuccess = (payload) => {
    return {
        type: MASTERBALANCE_SUCCESS,
        payload: payload,
    };
};
  
const masterBalanceFailure = (error) => {
    return {
        type: MASTERBALANCE_FAILURE,
        payload: error,
    };
};

export const callGetVirtualAccountSubAccountBalance = () => {
    return async (dispatch) => {
        dispatch(virtualAccountSubAccountBalanceRequest());
        try {
            var vaResponse = await getVirtualAccountSubAccountBalance();
            var bankSubledgerResponse = await getBankSubledgerSubAccountBalance();

            var result = [];
            if (vaResponse && vaResponse.length > 0) {
                result = result.concat(vaResponse);
            }

            if (bankSubledgerResponse && bankSubledgerResponse.length > 0) {
                result = result.concat(bankSubledgerResponse);
            }

            // return data
            dispatch(virtualAccountSubAccountBalanceSuccess(result));
        } catch (error) {
            dispatch(virtualAccountSubAccountBalanceFailure(error.message));
        }
    };
};  
  
const virtualAccountSubAccountBalanceRequest = () => {
    return {
        type: VIRTUALACCOUNTSUBACCOUNTBALANCE_REQUEST,
    };
};
  
const virtualAccountSubAccountBalanceSuccess = (payload) => {
    return {
        type: VIRTUALACCOUNTSUBACCOUNTBALANCE_SUCCESS,
        payload: payload,
    };
};
  
const virtualAccountSubAccountBalanceFailure = (error) => {
    return {
        type: VIRTUALACCOUNTSUBACCOUNTBALANCE_FAILURE,
        payload: error,
    };
};

export const callGetCustomerTransactions = () => {
    return async (dispatch) => {
        dispatch(customerTransactionRequest());
        try {
            var response = await getCustomerTransactions();
            // return data
            dispatch(customerTransactionSuccess(response));
        } catch (error) {
            dispatch(customerTransactionFailure(error.message));
        }
    };
};  
  
const customerTransactionRequest = () => {
    return {
        type: CUSTOMERTRANSACTION_REQUEST,
    };
};
  
const customerTransactionSuccess = (payload) => {
    return {
        type: CUSTOMERTRANSACTION_SUCCESS,
        payload: payload,
    };
};
  
const customerTransactionFailure = (error) => {
    return {
        type: CUSTOMERTRANSACTION_FAILURE,
        payload: error,
    };
};

export const getFxRateRef = (customerTier) => {
    return async (dispatch) => {
        dispatch(getFxRateRefReq());
        try {
            let res = await getFxRateRefApi(1000);
            dispatch(getFxRateRefReqSuccess(res));
        } catch (error) {
            dispatch(getFxRateRefReqFailure(error.message));
        }
    }
}

export const getFxRateRefRegular = () => {
    return async (dispatch) => {
        dispatch(getFxRateRefReq());
        try {
            let res = await getFxRateRefApi(1000,true);
            dispatch(getFxRateRefRegularSuccess(res));
        } catch (error) {
            dispatch(getFxRateRefReqFailure(error.message));
        }
    }
}

const getFxRateRefReq = () => {
    return ({
        type: FX_RATE_REF_REQ
    })
}


const getFxRateRefReqSuccess = (response) => {
    return ({
        type: FX_RATE_REF_SUCCESS,
        payload: response
    })
}

const getFxRateRefRegularSuccess = (response) => {
    return ({
        type: FX_RATE_REF_SUCCESS_REGULAR,
        payload: response
    })
}

const getFxRateRefReqFailure = (msg) => {
    return ({
        type: FX_RATE_REF_FAILURE,
        error: msg
    })
}

